import * as ReactDOM from 'react-dom'

import App, { MapInitProps } from './App'
import { MapContext } from './components/MapContext'

window['FinvizInitCanvas'] = async function initCanvas(props: MapInitProps) {
  const root = document.getElementById('root')

  ReactDOM.render(
    <MapContext>
      <App {...props} />
    </MapContext>,
    root
  )
}
